import React from "react";
import {
  MonitorPlay,
  BookOpen,
  CircleCheck,
  Timer,
  BadgeCheck,
  ArrowUpRight,
} from "lucide-react";
import quizImage from './Copertina.png'

const AulaMultimediale = () => {
  return (
    <section
      id="aula-multimediale"
      className="bg-white py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">

        {/* HEADER */}
        <div className="max-w-3xl">

          <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#D62828] mb-4">
            Il nostro punto di forza
          </p>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-[#123B6D] leading-[1.05]">
            Imparare a guidare
            <br />
            inizia dall'aula.
          </h2>

          <p className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed max-w-2xl">
            Un'aula multimediale pensata per rendere lo studio della teoria
            più semplice, coinvolgente e concreto.
          </p>

        </div>


        {/* CONTENUTO */}
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-center mt-16">


          {/* SCHERMO */}
          <div className="lg:col-span-7">

            <div className="relative">

              {/* DECORAZIONE */}
              <div className="absolute -top-8 -left-8 w-32 h-32 rounded-full bg-[#D62828]/5" />

              <div className="absolute -bottom-10 -right-10 w-40 h-40 rounded-full border-[35px] border-[#123B6D]/5" />


              {/* MONITOR */}
              <div className="relative z-10 rounded-[2rem] bg-[#123B6D] p-4 md:p-6 shadow-2xl">

                {/* TOP BAR */}
                <div className="flex items-center justify-between px-3 pb-4">

                  <div className="flex gap-2">
                    <span className="w-2.5 h-2.5 rounded-full bg-white/30" />
                    <span className="w-2.5 h-2.5 rounded-full bg-white/30" />
                    <span className="w-2.5 h-2.5 rounded-full bg-white/30" />
                  </div>

                  <span className="text-xs font-semibold text-white/40">
                    SIMULAZIONE ESAME
                  </span>

                </div>


                {/* SCHERMATA */}
       <div className="rounded-2xl overflow-hidden">
  <img
    src={quizImage}
    alt="Quiz patente B"
    className="w-full h-auto block"
  />
</div>


                {/* SUPPORTO MONITOR */}
                <div className="flex justify-center pt-5">
                  <div className="w-28 h-2 rounded-full bg-white/20" />
                </div>

              </div>

            </div>

          </div>


          {/* TESTO / VANTAGGI */}
          <div className="lg:col-span-5">

            <div className="space-y-7">


              {/* ITEM 1 */}
              <div className="flex gap-5">

                <div className="shrink-0 w-12 h-12 rounded-xl bg-[#123B6D]/5 flex items-center justify-center text-[#123B6D]">
                  <MonitorPlay size={23} strokeWidth={1.8} />
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#123B6D]">
                    Lezioni multimediali
                  </h3>

                  <p className="mt-2 text-slate-500 leading-relaxed">
                    Spiegazioni supportate da immagini, video e contenuti
                    interattivi per comprendere meglio ogni argomento.
                  </p>
                </div>

              </div>


              {/* ITEM 2 */}
              <div className="flex gap-5">

                <div className="shrink-0 w-12 h-12 rounded-xl bg-[#123B6D]/5 flex items-center justify-center text-[#123B6D]">
                  <BookOpen size={23} strokeWidth={1.8} />
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#123B6D]">
                    Teoria più semplice
                  </h3>

                  <p className="mt-2 text-slate-500 leading-relaxed">
                    Un metodo pensato per rendere anche gli argomenti più
                    complessi facili da capire e ricordare.
                  </p>
                </div>

              </div>


              {/* ITEM 3 */}
              <div className="flex gap-5">

                <div className="shrink-0 w-12 h-12 rounded-xl bg-[#123B6D]/5 flex items-center justify-center text-[#123B6D]">
                  <BadgeCheck size={23} strokeWidth={1.8} />
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#123B6D]">
                    Preparazione all'esame
                  </h3>

                  <p className="mt-2 text-slate-500 leading-relaxed">
                    Quiz e simulazioni per arrivare all'esame con una
                    preparazione concreta e maggiore sicurezza.
                  </p>
                </div>

              </div>


              {/* CTA */}
              <a
                href="#contatti"
                className="
                  inline-flex
                  items-center
                  gap-3
                  mt-4
                  px-6
                  py-3.5
                  rounded-xl
                  bg-[#D62828]
                  hover:bg-[#b91f1f]
                  text-white
                  font-semibold
                  transition-all
                  duration-200
                  group
                "
              >
                Scopri l'aula multimediale

                <ArrowUpRight
                  size={19}
                  className="transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </a>

            </div>

          </div>

        </div>


        {/* BOTTOM FEATURE BAR */}
        <div className="mt-20 rounded-3xl bg-[#123B6D] px-7 py-8 md:px-10 md:py-9">

          <div className="grid sm:grid-cols-3 gap-7">

            <div className="flex items-center gap-4">
              <CircleCheck className="text-white shrink-0" size={24} />
              <span className="text-white font-medium">
                Quiz e simulazioni
              </span>
            </div>

            <div className="flex items-center gap-4">
              <MonitorPlay className="text-white shrink-0" size={24} />
              <span className="text-white font-medium">
                Supporto multimediale
              </span>
            </div>

            <div className="flex items-center gap-4">
              <BadgeCheck className="text-white shrink-0" size={24} />
              <span className="text-white font-medium">
                Preparazione all'esame
              </span>
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default AulaMultimediale;